import { useContext, useEffect, useState } from 'react'
import { MentorClinicsContext } from 'src/mentor/layout'
import { AvailabilityPageContainer } from '../MentorAvailabilityPage/MentorAvailabilityPageStyles'
import MentorHeader from '../MentorHeader'
import TeacherPayoutReports from './TeacherPayoutReports'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import { getSPDataWithParams } from 'src/supportPortal/services/services'

export default function MentorPayoutReports({ eventType, showSummaryReport = false }) {
  const { associatedClinicBrands, associatedClinicsData, loadingAssociationsData } =
    useContext(MentorClinicsContext)
  const [allEventTypes, setAllEventTypes] = useState([])

  const { mentorClinicAssociationData } = useContext(MentorProfileContext)

  const [selectedClinicBrandId, setSelectedClinicBrandId] = useState()

  async function getAllEventTypes() {
    const resp = await getSPDataWithParams(`/api/health/event-types`, {})
    if (resp.status === 200) {
      setAllEventTypes(resp?.data?.sort((a, b) => a?.title?.localeCompare(b?.title)))
    }
  }

  useEffect(() => {
    if (associatedClinicBrands && associatedClinicBrands?.length > 0) {
      setSelectedClinicBrandId(associatedClinicBrands?.[0]?.id)
    }
  }, [associatedClinicBrands])

  useEffect(() => {
    getAllEventTypes()
  }, [])

  return (
    <AvailabilityPageContainer>
      <MentorHeader heading={`Your Payout Reports`} />
      <TeacherPayoutReports
        bookedEventLogApiUrl="/api/secure/teacher/booked-event-info/logs/get"
        apiUrl={'/api/secure/teacher/payout-reports/paginated'}
        // eventType={eventType}
        //   thisClinicBrandData={selectedClinicBrand}
        showSummaryReport={showSummaryReport}
        clinicAssociationData={associatedClinicBrands}
        allEventTypes={allEventTypes}
      />
      {/* {!loadingAssociationsData ? (
        <>
          {selectedClinicBrandId && (
            
          )}
        </>
      ) : (
        <CircularProgress />
      )} */}
    </AvailabilityPageContainer>
  )
}

// {associatedClinicBrands?.length > 1 && (
//     <Tabs
//       sx={{ px: 2 }}
//       value={selectedClinicBrandId}
//       onChange={(e, val) => {
//         console.log({ e, val })
//       }}
//     >
//       {associatedClinicBrands?.map((brand) => (
//         <Tab
//           label={brand?.brandName || brand?.title || ''}
//           key={brand?.id}
//           value={brand?.id}
//         />
//       ))}
//       {/* <Tab label="Item Two" {...a11yProps(1)} />
//   <Tab label="Item Three" {...a11yProps(2)} /> */}
//     </Tabs>
//   )}
